import React from 'react';
import { motion } from 'framer-motion';

const workplaceData = [
    {
        id: 1,
        title: "Make work work for you",
        description: "Let us take the work off your plate. We handle it with care, speed, and quality so you can focus on what truly matters while we deliver reliable results for you."
    },
    {
        id: 2,
        title: "Form connections in real life",
        description: "Form real-life connections through simple conversations, shared moments, and genuine care. Meet people, listen openly, and build relationships that feel real, meaningful, and lasting beyond screens and everyday interactions naturally."
    },
    {
        id: 3,
        title: "Be present with clients",
        description: "Be truly present with your clients, listen without distraction, understand their needs, and respond with care. Build trust through genuine conversations, empathy, and consistent support that shows you really value them."
    }
];

const MobikodeWorkplaceSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="max-w-[850px] mb-[32px] md:mb-[60px]"
                >
                    <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[16px]">
                        Mobikode workplace: be empowered
                    </h2>
                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6]">
                        How, when, and where you work will depend on your role and location, but flexibility is at the heart of it. In fact, 85% of our people feel empowered by the way they work.
                    </p>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[16px] md:gap-[24px]"
                >
                    {workplaceData.map((card) => (
                        <motion.div
                            key={card.id}
                            variants={fadeUpVariant}
                            className={`group relative flex flex-col bg-white border border-[#01386A45] p-[24px] sm:p-[30px] md:p-[40px] h-full min-h-[220px] sm:min-h-[280px] md:min-h-[320px] transition-all duration-300 overflow-hidden cursor-default md:hover:-translate-y-1 ${card.id === 3 ? 'sm:col-span-2 md:col-span-1' : ''
                                }`}
                        >
                            <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] mb-[16px] sm:mb-[30px]">
                                {card.title}
                            </h3>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] mt-auto relative z-10">
                                {card.description}
                            </p>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-0"></div>

                            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-10"></div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default MobikodeWorkplaceSection;